import React from "react";
import Navigation from "../components/site/Navigation";
import Footer from "../components/site/Footer";
import ShowcaseSection from "../components/site/ShowcaseSection";
import OrientationResetCheckoutHost from "../components/site/OrientationResetCheckoutHost";
import BookCheckoutHost from "../components/site/BookCheckoutHost";
import BlueprintCheckoutHost from "../components/site/BlueprintCheckoutHost";
import PageSeo from "../components/site/PageSeo";
import { SITE_URL, ORGANIZATION, PERSON } from "../data/entityGraph";

/**
 * /proof - the full Project Gallery and Showcase.
 *
 * Homepage carries only a 3-card teaser to keep the funnel short.
 * Visitors who want the full gallery, case studies, and filtering
 * UX land here. ShowcaseSection is reused exactly as it lives so
 * any future updates to the showcase data flow into both surfaces.
 */
const ProofPage = () => {
  const breadcrumbLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
      { "@type": "ListItem", position: 2, name: "Proof", item: `${SITE_URL}/proof` },
    ],
  };
  const collectionLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": `${SITE_URL}/proof#collection`,
    url: `${SITE_URL}/proof`,
    name: "Proof Gallery | Authentic Momentum",
    about: { ...PERSON },
  };

  return (
    <>
      <PageSeo
        title="Proof Gallery | Authentic Momentum Case Studies"
        description="Real work, real outcomes. The Authentic Momentum project gallery of brand systems, founder platforms, and creator builds shipped by Cyrus Prescod."
        canonical={`${SITE_URL}/proof`}
        jsonLd={[collectionLd, breadcrumbLd, { "@context": "https://schema.org", ...ORGANIZATION }]}
      />
      <Navigation />
      <main className="relative pt-16 min-h-screen">
        <ShowcaseSection />
      </main>
      <Footer />
      <BookCheckoutHost />
      <BlueprintCheckoutHost />
      <OrientationResetCheckoutHost />
    </>
  );
};

export default ProofPage;
